import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("grading_monitoring")
export class GradingMonitoring {

    @PrimaryGeneratedColumn("increment", { name: 'grading_monitoring_id' })
        gradingMonitoringId: number;


    @Column('int', {
        nullable: true,
        name: "grad_inv_id"
    })
    gradingInventoryId: number; 
    

    @Column({
        type: 'varchar',
        nullable: false,
        name: 'type_of_product'
    })
    typeOfProduct: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'headless_count'
    })
    headlessCount: number;


    
    @Column("varchar", {
    nullable: false,
    length: 30,
    name: "quality_eval"
    })
    qualityEval: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "icinig"
    })
    icing: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "temp_of_product"
    })
    tempOfProduct: string;

    
    @Column({
        type: 'int',
        nullable: false,
        name: 'chlorine_level'
    })
    chlorineLevel: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grades_obtained'
    })
    gradesObtaine: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'observed_count'
    })
    observedCount: number;

    @Column({
        type: 'varchar',
        nullable: true,
        name: 'corrective_action'
    })
    correctiveAction: string;

    @Column({
        type: 'varchar',
        nullable: true,
        name: 'sign_of_supervisor'
    })
    signOfSupervisor: string;

    @Column({

        type: 'varchar',
        nullable: true,
        name: 'verification_by_qc'
    })
    verificationByQC: string;

   @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

  
}